import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ConfigProvider } from "antd";
import "./App.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: "hsl(200 80% 50%)",
        colorBgContainerDisabled: "hsl(200 80% 40%)",
        colorTextDisabled: "hsl(1 0% 80%)",
      },
      components: {
        Button: {
          contentFontSizeLG: "3rem",
          primaryShadow:
            "inset 0 2px 2px #ffffff70, /* top highlight */ 0 7px 4px #00000030, 0 10px 10px #00000015",
          defaultShadow:
            "inset 0 1px 2px #ffffff70, /* top highlight */ 0 4px 6px #00000030, 0 6px 10px #00000015",
          boxShadow:
            "inset 0 1px 2px #ffffff70, /* top highlight */ 0 4px 6px #00000030, 0 6px 10px #00000015",
          colorText: "white",
          colorBorder: "transparent",
          colorBgContainer: "transparent",
          colorPrimaryBorder: "none",
        },
        Menu: {
          iconSize: "inherit",
        },
        Form: {
          labelFontSize: 24,
          labelColor: "hsl(1 0% 95%)",
          itemMarginBottom: 48,
        },
        Input: {
          colorText: "hsl(1 0% 95%)",
        },
      },
    }}
  >
    <App />
  </ConfigProvider>
);
